var is_clicked = false;
var timeout = null;

(function($) {
  $(document).ready(function() {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        $('.back-top').addClass('active');
      } else {
        $('.back-top').removeClass('active');
      }
    });

    $('.back-top').click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 1600);

      return false;
    });

    $('.product-swatches li').click(function() {
      var d = new Date();
      var n = d.getTime();
      $('.product-swatches li').removeClass('active');
      $(this).addClass('active');
      var img = $(this).find('div.hidden a').attr('href');
      $(this).parents('.product-item').find('.img-second > img').attr('src', img + '?' + n);
      $(this).parents('.product-item').find('.img-second').css({'opacity':'1', 'visibility':'visible', 'z-index':'2'});
    });


    if (window.use_color_swatch) {
      $('.swatch :radio').change(function() {
        var option_index = $(this).closest('.swatch').data('option-index');
        var option_value = $(this).val();
        $(this).closest('form').find('.single-option-selector').eq(option_index).val(option_value).trigger('change');
      });
    }
  });

  if ($(".col-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!is_clicked) {
        getParams();
        var new_url = createUrl();
        filterGetContent(new_url);
        reSidebar();
      }
      is_clicked = false;
    });
  }

  $(document).ready(function() {
    init();
  });

  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      if ($('.modal').is(':visible')) {
        $('.modal').fadeOut();
      }
      closeQuickViewPopup();
    }
  });
})(jQuery)


function init() {
  initModal();
  initMiniCart();
  AddToCart();
  AddToCart_ProductPage();
  initProductImageGallery();
  elevateZoom();
  QuickView();
  AddWishlist();
  AddWishlistProduct();
  extendOwlCarousel();
  initCollectionSidebar();
  initMobileMenu();
  initLoadMore();
  initReloadSortBy();
}


function initMiniCart() {
  checkItemsInMiniCart();

  $('.header-minicart .btn-remove').click(function(e) {
    e.preventDefault();
    var product_id = $(this).parents('li.item').data('product_id');
    Shopify.removeItem(product_id, function(cart) {
      AjaxUpdateMiniCart(cart);
    });
  });
}


function AddToCart() {
  if ($('.addtocart').length > 0) {

    $(document).on('click', '.addtocart', function(e) {
      self = $(this);
      e.preventDefault();
      if ($(this).attr('disabled') != 'disabled') {
        var productId = $(this).data('product-id');
        var form = $(this).parents('form');

        if (!window.ajax_cart) {
          $('#product-actions-' + productId).submit();
        }
        else {
          var variant_id = form.find('select[name=id]').val();
          if (!variant_id) {
            variant_id = form.find('input[name=id]').val();
          }

          var quantity = form.find('input[name=quantity]').val();
          if (!quantity) {
            quantity = 1;
          }

          var title = $(this).parents('.product-item').find('.product-title').html();
          var image = $(this).parents('.product-item').find('.product-image img').attr('src');

          AjaxAddToCart(variant_id, quantity, title, image);
        }
      }

      return false;
    })
  }
}


function AddToCart_ProductPage() {
  if ($('#AddToCart-product-template').length > 0) {
    $('#AddToCart-product-template').click(function(e) {
      e.preventDefault();
      if ($(this).attr('disabled') != 'disabled') {
        if (!window.ajax_cart) {
          $(this).parents('form').submit();
        } else {
          var variant_id = $(this).parents('form').find('select[name=id]').val();
          if (!variant_id) {
            variant_id = $(this).parents('form').find('input[name=id]').val();
          }
          var quantity = $(this).parents('form').find('input[name=quantity]').val();
          if (!quantity) {
            quantity = 1;
          }
          var title = $('.product-title h2').text();
          var image = $('#product-featured-image').attr('src');
          self = $(this);
          AjaxAddToCart(variant_id, quantity, title, image);
        }
      }

      return false;
    })
  }
}


function AjaxAddToCart(variant_id, quantity, title, image) {
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    beforeSend: function() {
      var text = self.data('load');
      self.html(text);
    },
    success: function(msg) {
      $('.ajax-success-modal').find('.product-title').html(title);
      $('.ajax-success-modal').find('.product-image').attr('src', image);
      $('.ajax-success-modal').find('.btn-view-wishlist').hide();
      $('.ajax-success-modal').find('.btn-view-cart').show();
      var text1 = self.data('default');
      setTimeout(function(){      
        showModal('.ajax-success-modal');self.html(text1); }, 1200);
      updateMiniCart();
    },
    error: function(xhr, text) {
      $('.loading-modal').hide();
      $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
      showModal('.ajax-error-modal');
    }
  });
}


function updateMiniCart() {
  Shopify.getCart(function(cart) {
    AjaxUpdateMiniCart(cart);
  });
}


function AjaxUpdateMiniCart(cart) {
  var html = '';
  html  += '<li class="item" data-product_id="{ID}">';
  html  += '<a href="{URL}" class="product-image">';
  html  += '<img src="{IMAGE}" alt="{TITLE}">';
  html  += '</a>';
  html  += '<div class="product-info">';
  html  += '<a href="javascript:void(0)" title="Remove This Item" class="btn-remove">x</a>';
  html  += '<div class="product-title">';
  html  += '<a href="{URL}">{TITLE}</a>';
  html  += '</div>';        
  html  += '</div>';
  html  += '<div class="product-price">';
  html  += '{QUANTITY} x <span class="price">{PRICE}</span>';
  html  += '</div>';
  html  += '</li>';

  $('.header-minicart #minicart-count').text(cart.item_count);
  $('.header-minicart .price-total .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
  $('.header-minicart .minicart-products-list').html('');
  if (cart.item_count > 0) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = html;
      item = item.replace(/\{ID\}/g, cart.items[i].id);
      item = item.replace(/\{URL\}/g, cart.items[i].url);
      item = item.replace(/\{TITLE\}/g, cart.items[i].title);
      item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
      item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
      item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
      $('.header-minicart .minicart-products-list').append(item);
    }

    $('.header-minicart .btn-remove').click(function(e) {
      e.preventDefault();
      var product_id = $(this).parents('li.item').data('product_id');
      Shopify.removeItem(product_id, function(cart) {
        AjaxUpdateMiniCart(cart);
      });
    });

    if (convertCurrency()) {
      Currency.convertAll(window.shop_currency, $('.currency-picker').data('value'), '.dropminicart-content span.money', 'money_format');
    }
  }
  checkItemsInMiniCart();
}


function checkItemsInMiniCart() {
  if ($('.header-minicart .minicart-products-list').children().length > 0) {
    $('.header-minicart .no-items').hide();
    $('.header-minicart .has-items').show();
  } else {
    $('.header-minicart .has-items').hide();
    $('.header-minicart .no-items').show();
  }
}


function AddWishlist() {
  $(document).on('click', 'button.wishlist', function(e) {
    e.preventDefault();
    var form = $(this).parent();
    var item = form.parents('.grid-item');
    $.ajax({
      type: 'POST',
      url: '/contact',
      data: form.serialize(),
      beforeSend: function() {
        AjaxLoading('show');
      },
      success: function(data) {
        AjaxLoading('hide');
        form.html('<a class="btn_primary added nou-btn" data-label="Wishlist" href="/pages/wish-list" title="Wishlist"><i class="icon-action-redo"></i><span class="hidden">Wishlist</span></a>');
        var title = item.find('.product-title').html();
        var image = item.find('a > img').attr('src');
        $('.ajax-success-modal').find('.product-title').html(title);
        $('.ajax-success-modal').find('.product-image').attr('src', image);
        $('.ajax-success-modal').find('.btn-view-wishlist').show();
        $('.ajax-success-modal').find('.btn-view-cart').hide();
        showModal('.ajax-success-modal');
      },
      error: function(xhr, text) {
        AjaxLoading('hide');
        $('.loading-modal').hide();
        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
        showModal('.ajax-error-modal');
      }
    });
  })
}


function AddWishlistProduct() {
  $('.product-single button.wishlist').click(function(e) {
    e.preventDefault();
    var form = $(this).parent();
    $.ajax({
      type: 'POST',
      url: '/contact',
      data: form.serialize(),
      beforeSend: function() {
        AjaxLoading('show');
      },
      success: function(data) {
        AjaxLoading('hide');
        form.html('<a class="btn_primary added nou-btn" data-label="Wishlist" href="/pages/wish-list" title="Wishlist"><i class="icon-action-redo"></i><span class="hidden">Wishlist</span></a>');
        var title = $('h1.product-title').html();
        var image = $('#product-featured-image').attr('src');
        $('.ajax-success-modal').find('.product-title').html(title);
        $('.ajax-success-modal').find('.product-image').attr('src', image);
        $('.ajax-success-modal').find('.btn-view-wishlist').show();
        $('.ajax-success-modal').find('.btn-view-cart').hide();
        showModal('.ajax-success-modal');
      },
      error: function(xhr, text) {
        AjaxLoading('hide');
        $('.loading-modal').hide();
        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
        showModal('.ajax-error-modal');
      }
    });
  })
}


function elevateZoom() {

  $('.more-view-image .product-photo-thumbs .owl-item:first-child a').addClass('actived');
  if (!$('.more-view-image-vertical .product-photo-thumbs a.elevatezoom-gallery').hasClass('actived')) {
    $('.more-view-image-vertical .product-photo-thumbs .owl-item:first-child a.elevatezoom-gallery').addClass('actived');
  }
  $('.more-view-image .product-photo-thumbs a.elevatezoom-gallery').click(function() {
    $('.more-view-image .product-photo-thumbs a.elevatezoom-gallery').removeClass('actived');
    $(this).addClass('actived');
  });
  if ($('#product-featured-image').length > 0) {
    if($(window).width()>1200){
      $("#product-featured-image").elevateZoom({
        loadingIcon: window.loading_url,
        gallery: 'more-view-slider',
        zoomType				: "inner",
        galleryActiveClass: 'actived',
        cursor: "default",
        scrollZoom: true
      })
    }
    else {
      $("#product-featured-image").elevateZoom({
        gallery: 'more-view-slider',
        cursor: 'pointer',
        galleryActiveClass: 'active',
        imageCrossfade: false,
        zoomType				: "inner",
        scrollZoom: false,
        onImageSwapComplete: function() {
          $(".zoomWrapper div").hide();
        },
        loadingIcon: window.loading_url
      });
    }
  }
}


function AjaxLoading(t) {
  if (t== 'show') {
    $('.ajax-loading').show();
  }
  else {
    $('.ajax-loading').hide();
  }
}


function initModal() {
  $('.btn-continue-shopping').click(function() {
    $('.ajax-success-modal').fadeOut(500);
  });

  $('.close-modal, .modal-overlay').click(function() {
    $('.ajax-success-modal').fadeOut(500);
  });
}


function showModal(el) {
  $(el).show();
  $(el).css('opacity', 1);
  timeout = setTimeout(function() {
    $(el).fadeOut(500);
  }, 5000);
}


function QuickView() {
  if ($('.quickview-button a').length > 0) {
    $(document).on('click', '.quickview-button a', function(e) {
      var product_handle = $(this).data('id');
      Shopify.getProduct(product_handle, function(product) {
        var template = $('#nou__quickview-template').html();
        $('.quick-view').html(template);
        var quickview = $('.quick-view');

        quickview.find('.product-title').html(product.title);
        if (quickview.find('.product-vendor span').length > 0) {
          quickview.find('.product-vendor span').text(product.vendor);
        }
        if (quickview.find('.product-type span').length > 0) {
          quickview.find('.product-type span').text(product.type);
        }
        if (quickview.find('.product-inventory span').length > 0) {
          var variant = product.variants[0];
          var inventoryInfo = quickview.find('.product-inventory span');                      
          if (variant.available) {
            if (variant.inventory_management!=null) {
              inventoryInfo.text(window.inventory_text.in_stock);
            } else {
              inventoryInfo.text(window.inventory_text.many_in_stock);
            }
          } else {
            inventoryInfo.text(window.inventory_text.out_of_stock);
          }
        }
        if (quickview.find('.product-description').length > 0) {
          var description = product.description.replace(/(<([^>]+)>)/ig, "");
          var description = description.replace(/\[countdown\](.*)\[\/countdown\]/g, "");
          description = description.split(" ").splice(0, 20).join(" ") + "...";
          quickview.find('.product-description').text(description);
        }
        quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));
        quickview.find('.product-item').attr('id', 'product-' + product.id);
        quickview.find('.variants').attr('id', 'product-actions-' + product.id);
        quickview.find('.variants select').attr('id', 'product-select-' + product.id);

        if (product.compare_at_price > product.price) {
          quickview.find('.compare-price').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
        } else {
          quickview.find('.compare-price').html('');
        }

        if (!product.available) {
          quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
          quickview.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass('disabled').attr("disabled", "disabled");;
        } else {
          quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));
          if (window.use_color_swatch) {
            QuickView_Variants_Swatches(product, quickview);
          } else {
            QuickView_Variants(product, quickview);
          }
        }

        quickview.find(".button").on("click", function() {
          var oldValue = quickview.find(".quantity").val(),
              newVal = 1;
          if ($(this).text() == "+") {
            newVal = parseInt(oldValue) + 1;
          } else if (oldValue > 1) {
            newVal = parseInt(oldValue) - 1;
          }
          quickview.find(".quantity").val(newVal);

          if (quickview.find(".total-price").length > 0) {
            updatePriceQuickview();
          }
        });

        QuickView_Slider(product, quickview);
        AddToCart_QuickView();
  		$('.quick-view .more-view-image .product-photo-thumbs .owl-item:first-child a').addClass('actived');
        $('.quick-view .more-view-image .product-photo-thumbs .owl-item a').click(function(){
        	$('.quick-view .more-view-image .product-photo-thumbs .owl-item a').removeClass('actived');
          	$(this).addClass('actived');
        });
        $('.quick-view').fadeIn(500);
        if ($('.quick-view .total-price').length > 0) {
          $('.quick-view input[name=quantity]').on('change', updatePriceQuickview);
        }
      });

      return false;
    });

    $(document).on("click", ".quick-view .overlay, .close-quickview, .qv-overlay", function() {
      closeQuickViewPopup();
      return false;
    });
  }
}


function closeQuickViewPopup() {
  $('.quick-view').fadeOut();
}


function QuickView_Variants_Swatches(product, quickview) {
  if (product.variants.length > 1) {
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
      quickview.find('form.variants > select').append(option);
    }

    var file_url  = window.file_url.substring(0, window.file_url.lastIndexOf('nou_?'));
    var asset_url   = window.asset_url.substring(0, window.asset_url.lastIndexOf('nou_?'));
    var options   = "";
    for (var i = 0; i < product.options.length; i++) {
      options += '<div class="swatch clearfix" data-option-index="' + i + '">';
      options += '<div class="header">' + product.options[i].name + '</div>';
      var is_color = false;
      if (/Color|Colour/i.test(product.options[i].name)) {
        is_color = true;
      }
      var optionValues = new Array();
      for (var j = 0; j < product.variants.length; j++) {
        var variant = product.variants[j];
        var value = variant.options[i];
        var valueHandle = this.convertToSlug(value);
        var Text = 'swatch-' + i + '-' + valueHandle;
        if (optionValues.indexOf(value) < 0) {
          options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';
          options += '<input id="' + Text + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';
          if (is_color) {
            options += '<label title="' + value + '" for="' + Text + '" style="background-color: ' + valueHandle + '; background-image: url(' + file_url + valueHandle + '.png)"><img class="crossed-out" src="' + asset_url + 'soldout.png" /></label>';
          } else {
            options += '<label title="' + value + '" for="' + Text + '">' + value + '<img class="crossed-out" src="' + asset_url + 'soldout.png" /></label>';
          }
          options += '</div>';
          if (variant.available) {
            $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
          }
          optionValues.push(value);
        }
      }
      options += '</div>';
    }

    quickview.find('form.variants > select').after(options);

    quickview.find('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').data('option-index');
      var optionValue = $(this).val();
      $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    });
  }
  else {
    quickview.find('form.variants > select').remove();
    quickview.find('form.variants').append('<input type="hidden" name="id" value="' + product.variants[0].id + '">');
  }
}


function QuickView_Variants(product, quickview) {

}


function convertToSlug(text) {
  var text = text.toLowerCase();
  text.replace(/[^a-z0-9 -]/g, '');
  text.replace(/\s+/g, '-');
  text.replace(/-+/g, '-');;
  return text;
}


function updatePriceQuickview() {
  var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
  var price = $('.quick-view .price').text().match(regex);
  if (!price) {
    regex = /([0-9]+[.|,][0-9]+)/g;
    price = $('.quick-view .price').text().match(regex);
  }

  if (price) {
    var unitPriceText = price[0];
    var unitPrice = unitPriceText.replace(/[.|,]/g, '');
    var quantity = parseInt($('.quick-view input[name=quantity]').val());
    var totalPrice = unitPrice * quantity;

    var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
    regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
    if (!totalPriceText.match(regex)) {
      regex = /([0-9]+[.|,][0-9]+)/g;
    } 
    totalPriceText = totalPriceText.match(regex)[0];

    var regInput = new RegExp(unitPriceText, "g");
    var totalPrice = $('.quick-view .price').html().replace(regInput, totalPriceText);

    $('.quick-view .total-price span').html(totalPrice);
  }
}


function AddToCart_QuickView() {
  if ($('.quick-view .addtocart').length > 0) {
    $(document).on('click', '.quick-view .addtocart', function() {
      var variant_id = $('.quick-view select[name=id]').val();
      if (!variant_id) {
        variant_id = $('.quick-view input[name=id]').val();
      }
      var quantity = $('.quick-view input[name=quantity]').val();
      if (!quantity) {
        quantity = 1;
      }

      var title = $('.quick-view .product-title a').html();
      var image = $('.quick-view .quickview-featured-image img').attr('src');
      AjaxAddToCart(variant_id, quantity, title, image);
      closeQuickViewPopup();
    });
  }
}


function QuickView_Slider(product, quickview) {
  var featured_image = Shopify.resizeImage(product.featured_image, 'grande');
  quickview.find('.quickview-featured-image').append('<a href="' + product.url + '"><img src="' + featured_image + '" title="' + product.title + '"/></a>');
  if (product.images.length > 1) {
    var $owlcarousel = quickview.find('.more-view-image ul');
    var count = 0;
    for (i in product.images) {
      if (count < product.images.length) {
        var grande_image = Shopify.resizeImage(product.images[i], 'grande');
        var compact_image = Shopify.resizeImage(product.images[i], 'compact');
        var item = '<li><a href="javascript:void(0)" data-image="' + grande_image + '"><img src="' + compact_image + '"  /></a></li>';
        $owlcarousel.append(item);

        count = count + 1;
      }
    }
    $owlcarousel.find('a').click(function() {
      var featured_image = quickview.find('.quickview-featured-image img');
      if ($(this).data('image') != featured_image.attr('src')) {
        featured_image.attr('src', $(this).data('image'));
      }
    });

    QuickView_OwlCarousel($owlcarousel);
  }
}


function QuickView_OwlCarousel(qvowlcarousel) {
  if (qvowlcarousel) {
    qvowlcarousel.owlCarousel({
      items: 5,
      nav: true,
      navText: ['', '',],
                margin: 10,
                responsive: {
                0:{
                items: 2
                },
                481:{
                items: 2
                },
                768:{
                items: 3
                },
                992:{
                items: 3
                },
                1200:{
                items: 4
                }
                }
                }).css('visibility', 'visible');
                }
                }


                function extendOwlCarousel() {
                $(".nou-owl.owl-carousel").each(function(){
                var owlCarousel = $(this);
                var nav     = owlCarousel.data("nav"),
                dots    = owlCarousel.data("dot"),
                autoplay  = owlCarousel.data("autoplay"),
                autospeed   = owlCarousel.data("autospeed"),
                speed     = owlCarousel.data("speed"),
                column1   = owlCarousel.data("column1"),
                column2   = owlCarousel.data("column2"),
                column3   = owlCarousel.data("column3"),
                column4   = owlCarousel.data("column4"),
                column5   = owlCarousel.data("column5"),
                margin    = owlCarousel.data("margin"),
                lazyLoad  = owlCarousel.data("lazyLoad");
                var config = {
                nav:          nav,
                dots:         dots,
                margin:       margin,
                autoplay:       autoplay,
                autospeed:      autospeed,
                speed:        speed,
                loop:         false,
                addClassActive:   true,
                navText: ['<i class="ps-icon--back"></i>', '<i class="ps-icon--next"></i>'],
      navClass: ["owl-prev", "owl-next"],
      afterAction: FirstLastActiveItem,
      responsive:{
        0:{
          items:1,
          nav:false
        },
        360:{
          items:column5,
          nav:false
        },
        481:{
          items:column4,
          nav:false
        },
        767:{
          items:column3,
          nav:false
        },
        991:{
          items:column2,
          nav:false
        },
        1199:{
          items:column1,
          nav: nav,
          loop:false
        }

      }
    };
                              if (autoplay){
      config.autospeed = autospeed;
    }
    owlCarousel.owlCarousel( config );
  });
}

function FirstLastActiveItem(el){
  el.find(".owl-item").removeClass("first");
  el.find(".owl-item.active").first().addClass("first");
  el.find(".owl-item").removeClass("last");
  el.find(".owl-item.active").last().addClass("last");
}


function initCollectionSidebar() {
  if ($('.col-sidebar').length > 0) {
    getParams();
    getSortby();
    filterEvents();
    getPaging();
    filterClear();
    filterClearAll();
  }
}


function getParams() {
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var key, i = 0, url = location.search.substr(1).split('&'); i < url.length; i++) {
      key = url[i].split('=');
      if (key.length > 1) {
        Shopify.queryParams[decodeURIComponent(key[0])] = decodeURIComponent(key[1]);
      }
    }
  }
}


function getSortby() {
  if (Shopify.queryParams.sort_by) {
    var sort_by = Shopify.queryParams.sort_by;
    var sortby_text = $(".filter-sortby a[href='" + sort_by + "']").text();
    $(".filter-sortby > button span").text(sortby_text);
    $(".filter-sortby li.active").removeClass("active");
    $(".filter-sortby a[href='" + sort_by + "']").parent().addClass("active");
  }
}


function filterEvents() {
  filterCategories();
  filterTags();
  filterMode();
  filterSortby();
}


function filterCategories() {
  $(".col-sidebar .block-categories a").click(function(e) {
    if (!$(this).hasClass('active')) {
      delete Shopify.queryParams.q;
      filterAjax($(this).attr('href'));

      $(".col-sidebar .block-categories a.active").removeClass("active");
      $(this).addClass("active");
    }
    e.preventDefault();
  });
}


function filterTags() {
  $(document).on('click', '.block-sidebar .filter-tag a:not(".clear"), .filter-tag label', function(e) {
    var current_tags = [];
    if (Shopify.queryParams.constraint) {
      current_tags = Shopify.queryParams.constraint.split('+');
    }

    if (!$(this).prev().is(":checked")) {
      var other_tag = $(this).parents('.filter-tag').find("input:checked");
      if (other_tag.length > 0) {
        var tag_name = other_tag.val();
        if (tag_name) {
          var tag = current_tags.indexOf(tag_name);
          if (tag >= 0) {
            current_tags.splice(tag, 1);
          }
        }
      }
    }

    var tag_name = $(this).prev().val();
    if (tag_name) {
      var tag = current_tags.indexOf(tag_name);
      if (tag >= 0) {
        current_tags.splice(tag, 1);
      } else {
        current_tags.push(tag_name);
      }
    }

    if (current_tags.length) {
      Shopify.queryParams.constraint = current_tags.join('+');
    } else {
      delete Shopify.queryParams.constraint;
    }

    filterAjax();
    e.preventDefault();
  })
}


function filterMode() {
  $(".modes a").click(function(e) {
    setTimeout(function(){ $('.grid--view-items .grid-item').matchHeight({byRow: true, property: 'height'}); }, 2000);
    if (!$(this).hasClass("active")) {
      if ($(this).hasClass("mode-list")) {
        Shopify.queryParams.view = "list";
      } else {
        Shopify.queryParams.view = '';
      }

      filterAjax();
      $(".modes a.active").removeClass("active");
      $(this).addClass("active");
      e.preventDefault();
    }
    e.preventDefault();
  });
}


function initReloadSortBy() {
  Shopify.queryParams = {};
  if ($('#sort-by').length) {
    $('#sort-by').change(function(e) {
      Shopify.queryParams.sort_by = $(this).val();
      window.location.href= '?sort_by=' + Shopify.queryParams.sort_by;
      //filterAjax();
      //e.preventDefault();
    })
  }
}


function filterSortby() {
  $('#sortby').change(function(e) {
    Shopify.queryParams.sort_by = $(this).val();
    //window.location.href= '?sort_by=' + Shopify.queryParams.sort_by;
    filterAjax();
    e.preventDefault();
  });
}


function filterAjax(urlLink) {
  delete Shopify.queryParams.page;
  var new_url = createUrl(urlLink);
  is_clicked = true;
  History.pushState({param: Shopify.queryParams}, new_url, new_url);
  filterGetContent(new_url);
}


function createUrl(urlLink) {
  var params = $.param(Shopify.queryParams).replace(/%2B/g, '+');
  if (urlLink) {
    if (params != "")
      return urlLink + "?" + params;
    else
      return urlLink;
  }

  return location.pathname + "?" + params;
}


function filterGetContent(new_url) {
  $.ajax({
    type: 'get',
    url: new_url,
    beforeSend: function() {
      AjaxLoading('show');
    },
    success: function(data) {
      getData(data);
      getPaging();
      filterTags();
      filterClear();
      filterClearAll();
      QuickView();
      AddToCart();
      AddWishlist();
      AjaxLoading('hide');
    },
    error: function(xhr, text) {
      AjaxLoading('hide');
      $('.loading-modal').hide();
      $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
      showModal('.ajax-error-modal');
    }
  });
}


function getData(data) {
  var current_html = $(".col-main .products-grid");
  if (current_html.length == 0) {
    current_html = $(".col-main .product-list");
  }

  var product_list = $(data).find(".col-main .products-grid");
  if (product_list.length == 0) {
    product_list = $(data).find(".col-main .product-list");
  }

  current_html.replaceWith(product_list);

  if (convertCurrency()) {
    Currency.convertAll(window.shop_currency, $('.currency-picker').data('value'), '.col-main span.money', 'money_format');
  }

  if ($(".paging").length > 0) {
    $(".paging").replaceWith($(data).find(".paging"));
  } else {
    $(".col-main").append($(data).find(".paging"));
  }

  var header_current  = $(".collection-header");
  var header_data     = $(data).find(".collection-header");
  if (header_current.find("h2").text() != header_data.find("h2").text()) {
    header_current.find("h2").replaceWith(header_data.find("h2"));

    var des_current = $(".collection-description");
    var des_data  = $(data).find(".collection-description");

    if (des_current.find(".rte").length) {
      if (des_data.find(".rte").length) {
        des_current.html(des_data.find(".rte"));
      } else {
        des_current.find(".rte").hide();
      }
    } else {
      des_current.html(des_data.find(".rte"));
    }

    var img_current = $(".collection-img");
    var img_data  = $(data).find(".collection-img");
    if (img_current.find("p").length) {
      if (img_data.find("p").length) {
        img_current.html(img_data.find("p"));
      } else {
        img_current.find("p").hide();
      }
    } else {
      img_current.html(img_data.find("p"));
    }
  }

  $(".block-sidebar").replaceWith($(data).find(".block-sidebar"));
}


function getPaging() {
  $(document).on('click', '.paging ul.pagination a', function(e) {
        setTimeout(function(){ $('.grid--view-items .grid-item').matchHeight({byRow: true, property: 'height'}); }, 2000);

    var page = $(this).attr("href").match(/page=\d+/g);
    if (page) {
      Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
      if (Shopify.queryParams.page) {
        var new_url = createUrl();
        is_clicked = true;
        History.pushState({param: Shopify.queryParams}, new_url, new_url);
        filterGetContent(new_url);

        $('body,html').animate({
          scrollTop: 500
        }, 600);
      }
    }
    e.preventDefault();
  })
}


function reSidebar() {
  $(".col-sidebar .block-categories .active, .filter-tag .active").removeClass("active");
  $(".filter-tag input:checked").attr("checked", false);

  var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
  if (cat && cat[1]) {
    $(".col-sidebar .block-categories a[href='" + cat[0] + "']").addClass("active");
  }

  if (Shopify.queryParams.view) {
    $(".modes .active").removeClass("active");
    var view = Shopify.queryParams.view;
    if (view.indexOf("list") >= 0) {
      $(".modes .list").addClass("active");
      view = view.replace("list", "");
    } else {
      $(".modes .grid").addClass("active");
    }
  }

  getSortby();
}


function initProductImageGallery() {
  if ($('.product-single .more-view-image').length > 0) {
    initOwlGallery();
  }else {
    if ($('.product-single .more-view-image-vertical').length) {
      initJCarouselGallery();
    }
  }
}


function initOwlGallery() {
  $('.more-view-image #more-view-slider').owlCarousel({
    items: 4,
    margin: 30,
    dots: false,
    nav: false,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0:{items: 3},
      481:{items: 3},
      768:{items: 3},
      992:{items: 3},
      1200:{items: 4}
    }
  });
}


function initJCarouselGallery() {
  $('.more-view-image-vertical ul').jcarousel({
    vertical: true        
  }).css('visibility', 'visible');

  $('.product-img-box').addClass('has-jcarousel');
  $('.more-view-wrapper').css('visibility', 'visible');
}


function filterClear() {
  $(".filter-tag").each(function() {
    var filter_tag = $(this);
    if (filter_tag.find("input:checked").length > 0) {
      filter_tag.find(".clear").show().click(function(e) {
        var current_tags = [];
        if (Shopify.queryParams.constraint) {
          current_tags = Shopify.queryParams.constraint.split('+');
        }
        filter_tag.find("input:checked").each(function() {
          var selected_tag = $(this);
          var tagName = selected_tag.val();
          if (tagName) {
            var tagPos = current_tags.indexOf(tagName);
            if (tagPos >= 0) {
              current_tags.splice(tagPos, 1);
            }
          }
        });
        if (current_tags.length) {
          Shopify.queryParams.constraint = current_tags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        filterAjax();
        e.preventDefault();
      });
    }
  });
}


function filterClearAll() {
  $('.col-sidebar a.clear-all').click(function(e) {
    delete Shopify.queryParams.constraint;
    delete Shopify.queryParams.q;
    filterAjax();
    e.preventDefault();
  });
}


function convertCurrency() {
  return window.show_multiple_currency && Currency.currentCurrency != shopCurrency;
}


function initMobileMenu() {

  $(document).on('click', '.menu-toggle', function() {
    $('body').removeClass('mobile-actived').addClass('mobile-actived');
    $(this).addClass('active');

  });
  $('span.closeMenu').on('click', function() {
    $('body').removeClass('mobile-actived');    

    $('.menu-toggle').removeClass('active');
  });

  $('.nav-mobile li > i.fa').on('click', function() {
    if ($(this).parent('li.dropdown').hasClass('menu-opened')) {
      $(this).removeClass('ion-ios-arrow-down').addClass('ion-ios-arrow-right');
      $(this).next().slideToggle(400);
      $(this).parent('li.dropdown').removeClass('menu-opened');
    }
    else {
      $(this).removeClass('ion-ios-arrow-right').addClass('ion-ios-arrow-down');
      $(this).next().slideToggle(400);
      $(this).parent('li.dropdown').removeClass('menu-opened').addClass('menu-opened');
    }
    return false;
  })
}


function initLoadMore() {
  if ($('.infinite-scrolling').length > 0) {
    $('.infinite-scrolling a').click(function(e) {
      e.preventDefault();
      if (!$(this).hasClass('disabled')) {
        doAjaxLoadMore();
      }
    });
  }
}


function doAjaxLoadMore() {
  var current_html = $(".col-main .products-grid");
  if (current_html.length == 0) {
    current_html = $(".col-main .product-list");
  }
  if (current_html) {
    var loadmore = $('.infinite-scrolling a').first();
    $.ajax({
      type: 'GET',
      dataType: "html",
      url: loadmore.attr("href"),
      beforeSend: function() {
        AjaxLoading('show');
      },
      success: function(data) {
        AjaxLoading('hide');
        var products = $(data).find(".col-main .products-grid");
        if (!products.length) {
          products = $(data).find(".col-main .product-list");
        }
        if (products.length) {
          current_html.append(products.children());

          AddToCart();
          QuickView();
          AddWishlist();

          if ($(data).find('.infinite-scrolling').length > 0) {
            loadmore.attr('href', $(data).find('.infinite-scrolling a').attr('href'));
          } else {
            //no more products
            loadmore.hide();
            loadmore.next().show();
          }

          if (convertCurrency()) {
            Currency.convertAll(window.shop_currency, $('.currency-picker').data('value'), '.dropminicart-content span.money', 'money_format');
          }

          if ($(".spr-badge").length > 0) {
            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
          }
        }
      },
      error: function(xhr, text) {
        AjaxLoading('hide');
        $('.loading-modal').hide();
        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
        showModal('.ajax-error-modal');
      }
    })
  }
}